export const placeTypes = {
    1 : {
        id: 1,
        name: 'Address',
        value: ['address']
    },
    2 : {
        id: 2,
        name: 'Establishment',
        value: ['establishment']
    },
    3 : {
        id: 3,
        name: 'City',
        value: ['(cities)']
    }, 
    4 : {
        id: 4,
        name: 'Neighborhood',
        value: ['neighborhood']
    }, 
}